/**
 * Represents TodoSettings object.
 */ export class TodoSettings {
    /**
     * Initializes a new instance of TodoSettings object.
     * @param todoSettingsResource object returned from todo service.
     */ constructor(todoSettingsResource){
        this.flaggedEmail = true;
        for (const todoSetting of todoSettingsResource){
            switch(todoSetting.Key){
                case "ListFlagged_Enabled":
                    this.flaggedEmail = todoSetting.Value?.toLowerCase() === "true";
                    break;
                default:
                    break;
            }
        }
    }
}
